import styled, { css } from "styled-components";

const textParagraphSmSemi = css`
  font-size: 0.875rem;
  line-height: 150%;
  font-weight: 600;
`;

const textParagraphSmRegular = css`
  font-size: 0.875rem;
  line-height: 150%;
  font-weight: 400;
`;

const textParagraphXsRegular = css`
  font-size: 0.75rem;
  line-height: 150%;
  font-weight: 400;
`;

const formSelect = css`
  background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAQCAYAAAAMJL+VAAAABGdBTUEAALGPC/xhBQAAAQtJREFUOBG1lEEOgjAQRalbGj2OG9caOACn4ALGtfEuHACiazceR1PWOH/CNA3aMiTaBDpt/7zPdBKy7M/DCL9pGkvxxVp7KsvyJftL5rZt1865M+Ucq6pyyF3hNcI7Cuu+728QYn/JQA5yKaempxuZmQngOwEaYx55nu+1lQh8GIatMGi+01NwBcEmhxBqK4nAPZJ78K0KKFAJmR3oPp8+Iwgob0Oa6+TLoeCvRx+mTUYf/FVBGTPRwDkfLxnaSrRwcH0FWhNOmrkWYbE2XEicqgSa1J0LQ+aPCuQgZiLnwewbGuz5MGoAhcIkCQcjaTBjMgtXGURMVHC1wcQEy0J+Zlj8bKAnY1/UzDe2dbAVqfXn6wAAAABJRU5ErkJggg==");
  background-size: 0.7rem;
  background-position: right 0.7rem center;
  background-repeat: no-repeat;
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const Label = styled.label`
  ${textParagraphSmSemi}
  margin-bottom: 0.5rem;
  color: ${props => props.color || "var(--text-title, #080404)"};
`;

export const Wrapper = styled.div`
  position: relative;
`;

export const SelectField = styled.select<{
  disabled?: boolean;
  borderColor?: string;
  $colorText?: string;
}>`
  border-radius: 4px;
  border-width: 1px;
  border-color: ${props => props.borderColor || "var(--general-border, #e2e8f0)"};
  padding: 1rem;
  height: 56px;
  color: #0f172a;
  width: 100%;
  appearance: none;
  background-repeat: no-repeat;

  ${({ disabled }) =>
    disabled &&
    `
      opacity: 0.5;
  `}

  ${({ $colorText }) =>
    $colorText &&
    css`
      color: ${$colorText};
      color-scheme: light;

      option {
        color: #0f172a;
        background-color: #ffffff;
      }
    `}

  ::placeholder {
    color: #64748b;
  }

  ${textParagraphSmRegular}
  ${formSelect}
`;

export const HelperText = styled.span`
  ${textParagraphXsRegular}
`;
